export default __webpack_public_path__ + "static/media/dashboard.89d53973.svg";